'use client';
import React, { useEffect, useRef, useState } from 'react';

function StartDemos() {
  const data = [
    {
      name: 'Home Main',
      type: 'dark',
      img: '/landing-preview/img/demos/01.jpg',
      link: '/dark/home-main',
    },
    {
      name: 'Home Main (light)',
      type: 'light',
      img: '/landing-preview/img/demos/1.jpg',
      link: '/light/home-main',
    },
    {
      name: 'Modern Startup',
      type: 'dark',
      img: '/landing-preview/img/demos/02.jpg',
      link: '/dark/home-startup-onepage',
    },
    {
      name: 'Modern Startup (light)',
      type: 'light',
      img: '/landing-preview/img/demos/2.jpg',
      link: '/light/home-startup-onepage',
    },

    {
      name: 'Creative Agency',
      type: 'dark',
      img: '/landing-preview/img/demos/03.jpg',
      link: '/dark/home-creative-agency',
    },
    {
      name: 'Creative Agency (light)',
      type: 'light',
      img: '/landing-preview/img/demos/3.jpg',
      link: '/light/home-creative-agency',
    },
    {
      name: 'Modern Agency',
      type: 'dark',
      img: '/landing-preview/img/demos/04.jpg',
      link: '/dark/home-modern-agency',
    },
    {
      name: 'Modern Agency (light)',
      type: 'light',
      img: '/landing-preview/img/demos/4.jpg',
      link: '/light/home-modern-agency',
    },
    {
      name: 'Creative Portfolio',
      type: 'dark',
      img: '/landing-preview/img/demos/05.jpg',
      link: '/dark/home-creative-portfolio',
    },
    {
      name: 'Creative Portfolio (light)',
      type: 'light',
      img: '/landing-preview/img/demos/5.jpg',
      link: '/light/home-creative-portfolio',
    },
    {
      name: 'Digital Agency',
      type: 'dark',
      img: '/landing-preview/img/demos/06.jpg',
      link: '/dark/home-digital-agency',
    },
    {
      name: 'Digital Agency (light)',
      type: 'light',
      img: '/landing-preview/img/demos/6.jpg',
      link: '/light/home-digital-agency',
    },
    {
      name: 'Freelancer',
      type: 'dark',
      img: '/landing-preview/img/demos/07.jpg',
      link: '/dark/home-freelancer',
    },
    {
      name: 'Freelancer (light)',
      type: 'light',
      img: '/landing-preview/img/demos/7.jpg',
      link: '/light/home-freelancer',
    },
    {
      name: 'Personal vCard',
      type: 'dark',
      img: '/landing-preview/img/demos/08.jpg',
      link: '/dark/home-personal-vcard',
    },
    {
      name: 'Personal vCard (light)',
      type: 'light',
      img: '/landing-preview/img/demos/8.jpg',
      link: '/light/home-personal-vcard',
    },
    {
      name: 'Minimal Portfolio',
      type: 'dark',
      img: '/landing-preview/img/demos/09.jpg',
      link: '/dark/home-minimal-portfolio',
    },
    {
      name: 'Minimal Portfolio (light)',
      type: 'light',
      img: '/landing-preview/img/demos/9.jpg',
      link: '/light/home-minimal-portfolio',
    },
    {
      name: 'Asymmetric Portfolio',
      type: 'dark',
      img: '/landing-preview/img/demos/010.jpg',
      link: '/dark/home-asymmetric-portfolio',
    },
    {
      name: 'Asymmetric Portfolio (ligth)',
      type: 'light',
      img: '/landing-preview/img/demos/10.jpg',
      link: '/light/home-asymmetric-portfolio',
    },
  ];
  const [filteredData, setFilteredData] = useState(data);
  function filter(event, type) {
    document
      .querySelectorAll('.filter-btn')
      .forEach((item) => item.classList.remove('active'));
    // console.log(filters);
    event.currentTarget.classList.add('active');
    setFilteredData(data.filter((item) => item.type === type));
  }
  return (
    <section
      className="demos section-padding pt-80 sub-bg2"
      data-scroll-index="0"
    >
      <div className="container-xxl">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">
            Create a Professional Website!
          </h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="d-rotate wow md-mb15">
              <span className="rotate-text">
                <span className="spc-font">20+ pre-made </span>
                <span> Home Pages.</span>
              </span>
            </h2>
            <div className="ml-auto">
              <div className="filtering">
                <div className="filter">
                  <span
                    onClick={() => setFilteredData(data)}
                    className="active filter-btn"
                  >
                    All
                  </span>
                  <span
                    className="filter-btn"
                    onClick={(event) => filter(event, 'dark')}
                  >
                    Dark
                  </span>
                  <span
                    className="filter-btn"
                    onClick={(event) => filter(event, 'light')}
                  >
                    Light
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="gallery-container row md-marg">
          {filteredData.map((item, i) => (
            <div key={i} className="col-lg-3 col-md-6 items dark">
              <div className="item text-center">
                <a href={item.link} target="_blank">
                  <div className="img">
                    <img src={item.img} alt="" />
                  </div>
                  <h6 className="mt-15">{item.name}</h6>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StartDemos;
